import { Checkbox, Dialog, TextInput } from '@cimplico/components';
import { useState } from 'react';
import { toastNotification } from '../../../components/toast/Toast';
import { useUpdateFileRecords } from '../../../queries/use-update-file-records';
import { FileRecordNew } from '../../../types/file-record';

type FileRecordRenameConfirmProps = {
    fileRecord: FileRecordNew;
    onClose: () => void;
};

function FileRecordRenameConfirm({ fileRecord, onClose }: FileRecordRenameConfirmProps): JSX.Element | null {
    const [renameReferences, setRenameReferences] = useState(false);
    const [name, setName] = useState(fileRecord?.name);
    const [nameError, setNameError] = useState('');

    const updateFileRecordsQuery = useUpdateFileRecords();

    function rename(): void {
        if (name !== fileRecord.name) {
            updateFileRecordsQuery.mutate([{ id: fileRecord.id, fields: { name }, updateReferences: renameReferences }], {
                onSuccess: () => {
                    onClose();
                    toastNotification('success', 'File record renamed!');
                },
                onError: (err) => {
                    setNameError(err.response?.data.results[0].error.fields.name);
                    toastNotification('error', 'Unable to rename file record!');
                },
            });
        }
    }

    function handleNameChange(name: string): void {
        setNameError('');
        setName(name);
    }

    if (!fileRecord) {
        return null;
    }

    return (
        <Dialog
            isOpen={true}
            description={`Do you want to rename ${fileRecord.name}? Any worksheets / other schedules that use this file will no longer be reviewed.`}
            title="Rename File Record"
            type="info"
            primaryAction="Rename"
            secondaryAction="Cancel"
            onPrimaryActionClick={rename}
            onClose={onClose}
            onSecondaryActionClick={onClose}
        >
            <div>
                <div className="pb-4">
                    <div className="pr-6 pb-4 mb-1">
                        <TextInput
                            defaultValue={fileRecord.name}
                            title="Name"
                            autoFocus
                            onChange={handleNameChange}
                            errorMessage={nameError}
                        />
                    </div>

                    <Checkbox
                        label="Rename all references of this file record."
                        onChange={(e): void => setRenameReferences(e.target.checked)}
                    />
                </div>
            </div>
        </Dialog>
    );
}
export default FileRecordRenameConfirm;
